import axios from '@/resources/libs/axios'

export default {
    search(data) {
        return axios.get(`/vhe/auxiliaries/products/list`, { params: data })
    },
    find(data) {
        return axios.get(`/vhe/auxiliaries/products/find/${data.id}`,{ params: data })
    },
    create(data) {
        return axios.post(`/vhe/auxiliaries/products/create`,  data)
    },
    update(data) {
        return axios.post(`/vhe/auxiliaries/products/update`,  data)
    },
    delete(id) {
        return axios.delete(`/vhe/auxiliaries/products/delete/${id}`)
    },
    listSubProducts(id){
        return axios.get(`/vhe/auxiliaries/products/subproducts/list/${id}`)
    },
    createSubProducts(data){
        return axios.post(`/vhe/auxiliaries/products/subproducts/create`,  data)
    },
    updateSubProducts(data){
        return axios.post(`/vhe/auxiliaries/products/subproducts/update`,  data)
    },
    deleteSubProducts(id) {
        return axios.delete(`/vhe/auxiliaries/products/subproducts/delete/${id}`)
    },
}